export type ProTVTarget = "3.x" | "2.3" | "2.2";

export type PlaylistFormat = "tokenized" | "json";

export type EntrySource = "youtube" | "manual" | "import";

export interface PlaylistEntry {
  id: string;
  mainUrl: string;
  alternateUrl: string;
  title: string;
  description: string;
  tags: string[];
  imagePath: string;
  source: EntrySource;
  youtubeVideoId?: string;
  thumbnailUrl?: string;
}

export interface PlaylistDocument {
  header: string;
  entries: PlaylistEntry[];
}

export interface ParseNotice {
  level: "info" | "warning";
  message: string;
}

export interface ParseResult {
  document: PlaylistDocument;
  detectedTarget: ProTVTarget;
  format: PlaylistFormat;
  notices: ParseNotice[];
}

export interface SerializeOptions {
  target: ProTVTarget;
  format: PlaylistFormat;
  urlPrefix?: string;
  includeImagePaths?: boolean;
}

export interface CompatibilityNotice {
  field: "alternateUrl" | "description" | "tags" | "imagePath" | "format";
  count: number;
  message: string;
}

export interface ValidationIssue {
  entryId: string;
  level: "error" | "warning";
  message: string;
}

export function createPlaylistEntry(
  values: Partial<Omit<PlaylistEntry, "id">> & Pick<PlaylistEntry, "mainUrl">,
  id: string = crypto.randomUUID(),
): PlaylistEntry {
  return {
    id,
    mainUrl: values.mainUrl.trim(),
    alternateUrl: values.alternateUrl?.trim() ?? "",
    title: values.title?.trim() ?? "",
    description: values.description?.trim() ?? "",
    tags: values.tags?.map((tag) => tag.trim()).filter(Boolean) ?? [],
    imagePath: values.imagePath?.trim() ?? "",
    source: values.source ?? "manual",
    youtubeVideoId: values.youtubeVideoId,
    thumbnailUrl: values.thumbnailUrl,
  };
}
